import React, { useState, useEffect, useRef } from 'react';
import { useAppStore } from '../../store';

interface HeaderProps {
  onShowLogin: () => void;
  onShowProfile: () => void;
}

const Header: React.FC<HeaderProps> = ({
  onShowLogin,
  onShowProfile
}) => {
  const { user, isAuthenticated, logout } = useAppStore();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);

  const handleLogout = async () => {
    await logout();
    setShowUserMenu(false);
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  // 点击外部关闭用户菜单
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  return (
    /* 用户操作区域 - 固定在右上角 */
    <div className="user-actions">
      {!isAuthenticated ? (
        /* 登录按钮 */
        <div className="auth-buttons" id="authButtons">
          <button
            className="auth-button login-btn"
            onClick={onShowLogin}
            title="登录"
          >
            <i className="fas fa-sign-in-alt"></i>
            <span>登录</span>
          </button>
        </div>
      ) : (
        /* 用户信息区域（登录后显示） */
        <div className="user-info" id="userInfo">
          <div className="user-avatar">
            <i className="fas fa-user-circle"></i>
          </div>
          <div className="user-details">
            <span className="user-name" id="userName">
              {user?.username || `用户${user?.phone}`}
            </span>
            <div className="user-menu" ref={userMenuRef}>
              <button
                className="user-menu-btn"
                onClick={toggleUserMenu}
              >
                <i className="fas fa-chevron-down"></i>
              </button>
              <div className={`user-dropdown ${showUserMenu ? 'show' : ''}`} id="userDropdown">
                <a href="#" onClick={(e) => { e.preventDefault(); onShowProfile(); setShowUserMenu(false); }}>
                  <i className="fas fa-cog"></i> 个人设置
                </a>
                <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                  <i className="fas fa-sign-out-alt"></i> 退出登录
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
